<template>
  <a-modal
    :visible="visible"
    :title="$t('markHistory.title')"
    :footer="null"
    width="720px"
    @cancel="$emit('close')"
  >
    <a-spin :spinning="loading">
      <a-table
        v-if="rows.length"
        :columns="columns"
        :data-source="rows"
        :pagination="false"
        row-key="_id"
        size="small"
      />
      <a-empty v-else-if="!loading" :description="$t('markHistory.empty')" />
    </a-spin>
  </a-modal>
</template>

<script>
import moment from "moment";

export default {
  name: "MarkHistoryModal",
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    rows: { type: Array, default: () => [] },
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("markHistory.date"),
          dataIndex: "changedAt",
          customRender: (text) =>
            text ? moment(text).format("DD/MM/YYYY HH:mm") : "—",
        },
        {
          title: this.$t("markHistory.user"),
          dataIndex: "changedBy",
          customRender: (_, row) =>
            row.changedBy ? row.changedBy.fullName : "—",
        },
        {
          title: this.$t("markHistory.role"),
          dataIndex: "changedBy",
          customRender: (_, row) => (row.changedBy ? row.changedBy.role : "—"),
        },
        {
          title: this.$t("markHistory.before"),
          dataIndex: "previousValue",
          customRender: (text) => this.formatValue(text),
        },
        {
          title: this.$t("markHistory.after"),
          dataIndex: "newValue",
          customRender: (text) => this.formatValue(text),
        },
        {
          title: this.$t("markHistory.action"),
          dataIndex: "action",
          customRender: (text) =>
            text ? this.$t(`markHistory.action_${text}`) : "—",
        },
      ];
    },
  },
  methods: {
    formatValue(value) {
      if (value === null || value === undefined) return "—";
      return String(value);
    },
  },
};
</script>
